'use client'
import React from 'react'
import CustomLink from '../../customLink'
import { convertHMS } from '@/shared/utils'
import ClockIconSVG from '@/shared/Icons/clockIcon'
import MyImage from '../../myImage'
import PlayIocn from '@/assets/images/icon/play-icon.svg'
import { useQuery } from '@apollo/client'
import { GET_SHORTS } from '@/graphql/videos/videos.query'

function PopularVideos() {
  const { data } = useQuery(GET_SHORTS, {
    variables: { input: { nSkip: 0, nLimit: 6, bShorts: false } }
  })
  const videos = data?.listVideosFront?.aResults || []
  return (
    <div className="w-full mb-4">
      <div className={`flex justify-between items-center mb-4`}>
        <h3 className="font-bold text-xl mb-0 flex items-center text-textOffWhite justify-center md:justify-start">
          <span>Popular Videos</span>
        </h3>
      </div>
      <div className="flex flex-col gap-6">
        {videos?.map((video: any, index: number) => {
          return (
            <CustomLink
              href={`/${video?.oSeo?.sSlug}`}
              key={index}
              className="flex items-center gap-3 group"
            >
              <div className="flex-shrink-0 w-[84px] rounded-lg relative">
                <span className=" absolute top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4 z-10 w-[26px] h-[26px]">
                  <MyImage src={PlayIocn} width={28} height={28} alt="playiocn" />
                </span>
                <MyImage
                  width={84}
                  height={68}
                  className="rounded-lg h-[68px] object-cover"
                  src={video?.aThumbnails[1]?.sUrl}
                />
              </div>
              <div className="group">
                <h6 className="text-base text-textOffWhite font-medium line-clamp-2 group-hover:text-primary-500 transition-all">
                  {video?.sTitle}
                </h6>
                <p className="flex items-center gap-1 md:gap-1.5 text-xs text-textDselected">
                  {' '}
                  <span className="w-3 h-3 flex flex-shrink-0 items-center justify-center">
                    <ClockIconSVG />
                  </span>{' '}
                  {convertHMS(video?.nDurationSeconds)}
                </p>
              </div>
            </CustomLink>
          )
        })}
        <div></div>
      </div>
    </div>
  )
}

export default PopularVideos
